'use client';

import {headerFallbackRu} from '@strapi/endpoints/Header/header.fallback';
import {convertStrapiHeaderLinksToProps} from '@utils/convertStrapiHeaderToProps';
import {useReportErrorFromBoundary} from '@utils/tracer/useReportErrorFromBoundary';
import error505 from '@web-landing/public/img/505.svg';
import {useMemo} from 'react';

import HeaderComponent from '@web-landing/components/StrapiHeader/Header';

import {Link} from '@strapi/types/Header';

import styles from './Error505.module.scss';

export const Error505 = ({error}: {error: Error & {digest?: string}}) => {
  useReportErrorFromBoundary(error, error.digest);

  const fallbackLinks = useMemo(
    () =>
      convertStrapiHeaderLinksToProps(
        headerFallbackRu.links as unknown as Array<Link>,
      ),
    [],
  );

  return (
    <>
      <HeaderComponent
        links={fallbackLinks}
        logo={{
          logoHref: headerFallbackRu.logo.logoHref.url,
          afterLogoImageHref: headerFallbackRu.logo.afterLogoImageHref.url,
          href: '/',
        }}
        page="main"
        mobileMenu={{mobileMenuTitle: 'Меню'}}
        cookieDomain=""
      />
      <div className={styles.wrapper}>
        <img src={error505.src} alt="505" />
        <h2 className={styles.title}>Что-то пошло не так</h2>
        <span className={styles.subtitle}>
          Попробуйте обновить страницу или зайти позже
        </span>
        <button
          className={styles.button}
          onClick={() => window.location.reload()}
        >
          Обновить страницу
        </button>
      </div>
    </>
  );
};
